import {
  QueryParamContextProvider,
  ReportingContextProvider,
  TabContextProvider,
  TimeFilterContextProvider,
} from 'modules/iterableGoals/contexts';
import 'modules/iterableGoals/ducks/sagas';
import { GoalAnalyticsPage } from './GoalAnalyticsPage';

export const GoalAnalyticsContext = () => {
  return (
    <QueryParamContextProvider>
      <ReportingContextProvider>
        <TabContextProvider>
          <TimeFilterContextProvider>
            <GoalAnalyticsPage />
          </TimeFilterContextProvider>
        </TabContextProvider>
      </ReportingContextProvider>
    </QueryParamContextProvider>
  );
};
